export default interface TipoFoto {
    name?:string;
    descricao?:string;
}

export const tiposFotosList: TipoFoto[] = [
    { name: "DIANTEIRA", descricao: "Dianteira"},
    { name: "TRASEIRA", descricao: "Traseira"},
    { name: "PAINEL", descricao: "Painel"},
    { name: "CHASSI", descricao: "Chassi"},
    { name: "MOTOR", descricao: "Motor"},
    { name: "INTERIOR", descricao: "Interior"},
    { name: "LATERAL_ESQUERDA", descricao: "Lateral esquerda"},
    { name: "LATERAL_DIREITA", descricao: "Lateral direita"},
    { name: "DOCUMENTO", descricao: "Documento"}
]